
export default function PrintMyIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 128 128"
      {...props}
    >
      <path
        fill="#40c0e7"
        d="M63.59 81.38h45.03c21.47 0 21.21-14.37 14.06-29.35c-9.75-19.45-12.23-19.45-27.25-19.45H32.62c-15.02 0-17.5 0-27.25 19.45c-7.14 14.98-7.41 29.35 14.06 29.35h45.03"
      ></path>
      <path
        fill="#196ca2"
        d="M28.56 38.02V25.73c0-2.43 1.8-4.4 4.02-4.4h62.9c2.22 0 4.01 1.97 4.01 4.4v12.28H28.56zm86.52 74.81H12.74C6.26 112.83 1 107.58 1 101.09V66.58c0-6.49 5.26-11.74 11.74-11.74h102.33c6.49 0 11.74 5.26 11.74 11.74v34.51c.01 6.49-5.25 11.74-11.73 11.74"
      ></path>
      <path
        fill="#2f2f2f"
        d="M98.91 119.83H29.09V96.11c0-3.24 1.39-5.86 3.1-5.86H95.8c1.71 0 3.1 2.63 3.1 5.86v23.72z"
      ></path>
      <path
        fill="#006ca0"
        d="M99.42 37.92c0-3.78-9.39-6.85-20.98-6.85H49.58c-11.59 0-20.98 3.07-20.98 6.85v.33c0 3.79 9.4 3.25 20.98 3.25h28.86c11.59 0 20.98.54 20.98-3.25z"
      ></path>
      <path
        fill="#fff"
        stroke="#78a3ad"
        strokeMiterlimit={10}
        strokeWidth={5}
        d="M92.5 35H36.25V11c0-1.24 1.03-2.24 2.31-2.24H90.2c1.27 0 2.31 1 2.31 2.24v24z"
      ></path>
      <path
        fill="#2f2f2f"
        d="M97.45 73.37H30.8c-1 0-1.8-.89-1.8-1.99v-7.02c0-1.1.81-1.99 1.8-1.99h66.64c1 0 1.8.89 1.8 1.99v7.02c.01 1.1-.8 1.99-1.79 1.99"
      ></path>
      <path
        fill="#78a3ad"
        d="M99.24 123.53v-20.6H87.68l.05 12.85c.42 1.63-1.13 3.16-3.19 3.16H43.73c-2.07 0-3.61-1.53-3.19-3.16l.05-12.85H29.03v20.6c-.8 2.1 1.15 4.22 3.87 4.22h62.46c2.73 0 4.68-2.12 3.88-4.22"
      ></path>
      <circle cx={111.5} cy={63.38} r={2.69} fill="#f79329"></circle>
      <circle cx={111.5} cy={71} r={2.69} fill="#bdcf46"></circle>
      <circle cx={64.17} cy={73.35} r={5.73} fill="#2f2f2f"></circle>
    </svg>
  );
}
